import React from "react";
import Aboutsection1 from "../Components/AboutPage/Aboutsection1";
import VisionMission from "../Components/AboutPage/VisionMission";
import Ourjourney from "../Components/AboutPage/Ourjourney";
import Flagship from "../Components/AboutPage/Flagship";
import Section2 from "../Components/AboutPage/Section2";
import Journey from "../Components/AboutPage/journey";
const AboutPage = () => {
  return (
    <div className="flex justify-center flex-col items-center text-left mb-10">

      <Aboutsection1 />
      <Section2/>
      <VisionMission />
      {/* <Ourjourney /> */}
      <Journey/>
      <Flagship />
    </div>
  );
};

export default AboutPage;
